/**
 * User: n.gorte
 * Date: 26.10.2020
 * Time: 15:39
 */



export const textLabelIcon = ({ bold, size, whiteBackground, underline, text, color }) => {
    let fontSize = size && parseInt(size);
    const backgroundColor = whiteBackground ? 'white' : '';
    const fontWeight = bold ? 800 : 400;
    const textDecoration = underline ? 'underline' : 'none';

    return L.divIcon({
        className: 'situation-map-text-label',
        html: `<span style="color:${color}; font-size: ${fontSize}px; font-weight: ${fontWeight}; text-decoration: ${textDecoration}; background-color: ${backgroundColor}">
                    ${text}
               </span>`
    });
};



// WEBPACK FOOTER //
// ./js/plugins/DrawerPlugin/TextLabelIcon.js